site.newsGalleryAlbum = {
	firstLoad: true,
	init: function () {
		if($('body.news .albumImagesOwl').length > 0) {
			site.owl.init('#news .albumImagesOwl', {
				loop: true,
				nav: true,
				dots: false,
				items: 1,
				lazyLoad: true,
				autoHeight: true,
				navText: ["<div class=\"arrow\"><i class=\"fa fa-angle-left\"></i></div>", "<div class=\"arrow\"><i class=\"fa fa-angle-right\"></i></div>"],
				animateOut: 'fadeOut',
				animateIn: 'fadeIn'
			});
		}
	}
};
site.inits.push('site.newsGalleryAlbum.init()');
